var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { st, classes } from './Avatar.base.st.css';
import { AnonymousIcon } from './AnonymousIcon';
import { nameToInitials } from './utils';
import { Image as WixImage, initCustomElement } from '@wix/image';
import { AVATAR_TEXT_TYPE } from './constants';
import { extractWixMediaId } from '../WowImage/utils';
const DEFAULT_CONTENT_TYPE = 'placeholder';
export function AvatarBase(_a) {
    var { name, src, onLoad, className, lettersLimit = 1, textType = AVATAR_TEXT_TYPE.initials } = _a, rest = __rest(_a, ["name", "src", "onLoad", "className", "lettersLimit", "textType"]);
    const [imgLoaded, setImgLoaded] = React.useState(false);
    const [contentType, setContentType] = React.useState(() => {
        return src ? 'image' : name ? 'text' : DEFAULT_CONTENT_TYPE;
    });
    const _onLoad = (event) => {
        setImgLoaded(true);
        onLoad && onLoad(event);
    };
    const _onError = () => {
        setContentType(name ? 'text' : DEFAULT_CONTENT_TYPE);
    };
    React.useEffect(() => {
        setContentType(src ? 'image' : name ? 'text' : DEFAULT_CONTENT_TYPE);
        setImgLoaded(false);
    }, [src]);
    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            initCustomElement();
        }
    }, []);
    function getContent(type) {
        switch (type) {
            case 'text': {
                return (React.createElement(TextAvatar, { name: name, lettersLimit: lettersLimit, textType: textType }));
            }
            case 'placeholder': {
                return React.createElement(AnonymousAvatar, null);
            }
            case 'image': {
                const imageSrc = extractWixMediaId(src) || src;
                return (React.createElement(React.Fragment, null,
                    !imgLoaded && (React.createElement("div", { className: classes.loadingWrapper }, name ? (React.createElement(TextAvatar, { name: name, lettersLimit: lettersLimit, textType: textType })) : (React.createElement(AnonymousAvatar, null)))),
                    React.createElement(WixImage, { height: undefined, width: undefined, className: st(classes.image, classes.content), alt: name, uri: imageSrc, name: imageSrc, onLoad: _onLoad, onError: _onError, displayMode: "fill" })));
            }
            default: {
                return null;
            }
        }
    }
    return (React.createElement("div", { "data-content-type": contentType, "data-img-loaded": imgLoaded, "data-hook": rest['data-hook'], title: name, "aria-label": name, className: st(classes.root, className) }, getContent(contentType)));
}
function TextAvatar({ name, lettersLimit = 1, textType = AVATAR_TEXT_TYPE.initials, }) {
    return (React.createElement("div", { className: classes.content, "data-hook": "text-container" }, textType === AVATAR_TEXT_TYPE.initials
        ? nameToInitials(name, lettersLimit)
        : name));
}
function AnonymousAvatar() {
    return React.createElement(AnonymousIcon, { className: st(classes.content, classes.anonymous) });
}
//# sourceMappingURL=Avatar.base.js.map